export default {
    tagged: '2.0.1-5cb6523',
    version: '2.0.1',
    revision: '5cb6523',
};
//# sourceMappingURL=version.js.map